import { LitheFC } from '@wheelbox/lithejs-engine';

import Icon from '../../../../layout/icon';

import { createId } from '../../../../../utils';

import { withSlice } from '../../../../../state';
import { GlobalSlice } from '../../../../../state/index.model';
import { APP_GLOBAL_SLICE } from '../../../../../constants/app';

type SearchInputProps = {
  value: string;
  isMatchCase: boolean;
  onToggleMatchCase: () => void;
  onInput: (value: string) => void;
  onKeyPress: (event: KeyboardEvent) => void;
};

const SearchInput: LitheFC<SearchInputProps> = ({
  id = createId(),
  testId = 'search-input',
  value,
  isMatchCase,
  onToggleMatchCase,
  onKeyPress,
  onInput,
}) => {
  const state = withSlice<GlobalSlice>(APP_GLOBAL_SLICE);
  return [
    'div',
    {
      id,
      'data-testid': testId,
      class: [
        'flex items-center gap-2 border rounded px-3 py-2',
        state.theme === 'dark'
          ? 'border-dark-text bg-dark-background'
          : 'border-text bg-background',
      ],
    },
    [
      'input',
      {
        id: `${id}-input-field`,
        class: [
          'flex-1 outline-none bg-transparent',
          state.theme === 'dark' ? 'text-dark-text' : 'text-text',
        ],
        onkeyup: onKeyPress,
        oninput: (e: InputEvent) =>
          onInput((e.target as HTMLInputElement).value),
        value,
      },
    ],
    Icon({
      icon: 'matchcase',
      classes: [
        'w-6 h-6 cursor-pointer hover:fill-primary',
        state.theme === 'dark' ? 'fill-dark-text' : 'fill-text',
        isMatchCase ? 'fill-primary' : '',
      ],
      onclick: onToggleMatchCase,
    }),
  ];
};

export default SearchInput;
